import { useQuery } from 'urql';
import { suburbPageQuery } from './suburbPageQuery';
import { getSlugFromPathname } from '../../helpers/getSlugFromPathname';
import { useUrlContext } from '../../contexts/UrlContext/UrlContext';
import { useFeatureRollout } from '@rea-argonaut/experiment';

export const useSuburbPageQuery = () => {
  const url = useUrlContext();

  const isFlatmatesBrickEnabled = useFeatureRollout('flatmates_brick_on_suburb_page').isEnabled();

  const [result] = useQuery({
    query: suburbPageQuery,
    variables: {
      slug: getSlugFromPathname(url.pathname),
      toggleFlatmatesBrick: isFlatmatesBrickEnabled,
    },
  });

  return result;
};
